module.exports = __webpack_public_path__ + "img/1491883155.9bed44ed.jpg";